import type { BoardModelKind } from "./kind";
import type {
  BoardModelDebugMeasurable,
  BoardModelDebugMeasureContext,
} from "./measurable";
import { applyBoardModelDebugMeasurable } from "./apply";
import type { BoardModelDebuggable } from "./debuggable";
import type { DebugFrameIdSets } from "./register";
import { registerDebuggableIds } from "./register";

export type EnsureDebugFrame = (
  host: HTMLElement,
  model: BoardModelKind,
  id: string,
) => HTMLElement;

export function syncBoardModelDebugFrame(
  host: HTMLElement,
  ensureFrame: EnsureDebugFrame,
  measurable: BoardModelDebugMeasurable,
  context: BoardModelDebugMeasureContext,
): HTMLElement {
  const frame = ensureFrame(host, measurable.kind, measurable.debugId);
  applyBoardModelDebugMeasurable(frame, measurable, context);
  return frame;
}

export function syncBoardModelDebuggables(
  host: HTMLElement,
  ensureFrame: EnsureDebugFrame,
  debuggables: readonly BoardModelDebuggable[],
  context: BoardModelDebugMeasureContext,
  idSets: DebugFrameIdSets,
): void {
  registerDebuggableIds(debuggables, idSets);
  for (const measurable of debuggables) {
    syncBoardModelDebugFrame(host, ensureFrame, measurable, context);
  }
}
